import React, { useEffect, useState } from "react";
import "./Projects.css";
import "../../i18n";
import { useTranslation } from "react-i18next";
import {
  project1,
  project2,
  project3,
  project4,
  project5,
  project6,
  github75x75,
  github75x75Black,
} from "../../assets/";

const Projects = () => {
  const { t, i18n } = useTranslation();
  const [isLightMode, setIsLightMode] = useState(false);

  const updateTheme = () => {
    const currentTheme = document.documentElement.getAttribute("data-theme");
    setIsLightMode(currentTheme === "light");
  };

  useEffect(() => {
    updateTheme();

    const observer = new MutationObserver(() => {
      updateTheme();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="projects" id="projects">
      <div className="wrapper">
        <div className="name">
          <p>{t("projects")}</p>
        </div>
        <div className="main-projects">
          <div className="projectCard">
            <div
              className="cardOfProject"
              id="project1"
              style={{
                backgroundImage: `url(${project1})`,
              }}
            >
              <div class="card__content">
                <div className="project-card-description">
                  {t("project1description")}
                </div>
                <div className="project-card-button">
                  <a
                    href="https://github.com/michalskijakub/OffRoadMobileApp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={isLightMode ? github75x75Black : github75x75}
                      alt="github75x75"
                      className="project-card-button"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="project-name">{t("project1name")}</div>
          </div>
          <div className="projectCard">
            <div
              className="cardOfProject"
              id="project2"
              style={{
                backgroundImage: `url(${project2})`,
              }}
            >
              <div class="card__content">
                <div className="project-card-description">
                  {t("project2description")}
                </div>
                <div className="project-card-button">
                  <a
                    href="https://github.com/michalskijakub/ErasmusProjectGame"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={isLightMode ? github75x75Black : github75x75}
                      alt="github75x75"
                      className="project-card-button"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="project-name">{t("project2name")}</div>
          </div>
          <div className="projectCard">
            <div
              className="cardOfProject"
              id="project3"
              style={{
                backgroundImage: `url(${project3})`,
              }}
            >
              <div class="card__content">
                <div className="project-card-description">
                  {t("project3description")}
                </div>
                <div className="project-card-button">
                  <a
                    href="https://github.com/michalskijakub/ReadingLicensePlates"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={isLightMode ? github75x75Black : github75x75}
                      alt="github75x75"
                      className="project-card-button"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="project-name">{t("project3name")}</div>
          </div>
          <div className="projectCard">
            <div
              className="cardOfProject"
              id="project1"
              style={{
                backgroundImage: `url(${project4})`,
              }}
            >
              <div class="card__content">
                <div className="project-card-description">
                  {t("project4description")}
                </div>
                <div className="project-card-button">
                  <a
                    href="https://github.com/michalskijakub/HandGestureRecognition"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={isLightMode ? github75x75Black : github75x75}
                      alt="github75x75"
                      className="project-card-button"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="project-name">{t("project4name")}</div>
          </div>
          <div className="projectCard">
            <div
              className="cardOfProject"
              id="project5"
              style={{
                backgroundImage: `url(${project5})`,
              }}
            >
              <div class="card__content">
                <div className="project-card-description">
                  {t("project5description")}
                </div>
                <div className="project-card-button">
                  <a
                    href="https://github.com/michalskijakub/frontend-currency-exchange-2023/tree/michalski_jakub"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={isLightMode ? github75x75Black : github75x75}
                      alt="github75x75"
                      className="project-card-button"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="project-name">{t("project5name")}</div>
          </div>
          <div className="projectCard">
            <div
              className="cardOfProject"
              id="project6"
              style={{
                backgroundImage: `url(${project6})`,
              }}
            >
              <div class="card__content">
                <div className="project-card-description">
                  {t("project6description")}
                </div>
                <div className="project-card-button">
                  <a
                    href="https://github.com/michalskijakub/OperatingSystems2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={isLightMode ? github75x75Black : github75x75}
                      alt="github75x75"
                      className="project-card-button"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="project-name">{t("project6name")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
